import { render, staticRenderFns } from "./DataManage.vue?vue&type=template&id=5c96f1a4&scoped=true&"
import script from "./DataManage.vue?vue&type=script&lang=js&"
export * from "./DataManage.vue?vue&type=script&lang=js&"
import style0 from "./DataManage.vue?vue&type=style&index=0&id=5c96f1a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96f1a4",
  null
  
)

export default component.exports